var datePickerDateFormat = "dd.mm.yy";

Vue.component('bus-search',{
    data: function () {
        return {
            disabled: false,
            mainPage: true,
            departure: {
                city: '',
                cityId: 0,
            },
            destination: {
                city: '',
                cityId: 0,
            },
            passengerCount: 1,
            date: '',
            returnDate: '',
            buses: [],
            departureEmpty: false,
            destinationEmpty: false,
        }
    },
    created: function(){
        this.listenPageChange();
    },
    mounted: function(){
        this.loadFromCookie();
        this.pageReloaded();
    },
    methods: {
        switchDestinations: function () {
            var temp = this.departure;
            this.departure = this.destination;
            this.destination = temp;
        },
        createWarning: function(){
            $( ".warningDialog" ).dialog({
                resizable: false,
                height:240,
                width:400,
                modal: true,
                buttons:
                    [
                        {
                            text: FmtMessage.getMessage('js.search.no.result'),
                            click: function() {
                                $( this ).dialog( "close" );
                            }
                        }
                    ]
            }).show();
        },
        search:function(){
            var vm = this;
            if (!this.isValidInput()){
                return;
            }
            openLoaderBox();
            this.disabled = true;

            var searchData = {
                departureCity: this.departure.city,
                destinationCity: this.destination.city,
                departureCityId: this.departure.cityId,
                destinationCityId: this.destination.cityId,
                departureDate: this.date,
                returnDate: this.returnDate,
                passengerCount: this.passengerCount,
                //searchTypeReserv: '',
                //roundTrip: '',
            };

            this.putCookie();

            $.ajax({
                type: "POST",
                url : "/bus/search/ajax/result",
                dataType : "json",
                data : searchData
            })
            .then(function (response) {
                if (!response.error && response.buses.length > 0){

                    var buses = response.buses;
                    buses.sort(function (item1, item2) {
                        return item1.departureDate - item2.departureDate;
                    });
                    vm.mainPage = false;
                    vm.$parent.setPassengerCount(vm.passengerCount);
                    vm.$parent.setBuses(buses);
                    vm.$parent.setGUID(response.guid);
                    var obj = {
                        destination: vm.destination.city,
                        departure: vm.departure.city
                    };

                    vm.$parent.setLocations(obj);


                    var url = window.location.href;
                    if (!url.includes("#")){
                        //location.replace(url + "#")
                        url = url + "#";
                        history.pushState(null, null, url)
                    }
                    
                    
                }
                else{
                    closeLoaderBox();
                    vm.createWarning();
                }

            })
            .fail(function (error) {
                closeLoaderBox();
                vm.createWarning();
            })
            .done(function () {
                closeLoaderBox();
                vm.disabled = false;
            });
        },
        isValidInput: function () {
            this.departureEmpty = this.departure.city == '';
            this.destinationEmpty = this.destination.city == '';

            return !this.departureEmpty && !this.destinationEmpty;
        },
        loadFromCookie: function() {
            var vm = this;
            if ($.cookie('busSearchParams')){
                var now = new Date();

                var search = JSON.parse($.cookie('busSearchParams'));

                vm.departure = search.departure;
                vm.destination = search.destination;

                vm.passengerCount = search.passengerCount;

                if(search.departureDate != null){

                    var date = $.datepicker.parseDate("dd.mm.yy", search.departureDate);
                    var formattedDate = search.departureDate;

                    if(now.getTime() > date.getTime()){
                        date = new Date();
                        formattedDate = $.datepicker.formatDate("dd.mm.yy", date);
                    }

                    $(".datepicker", document).datepicker("setDate", date);
                    $(".datepicker").val(formattedDate);
                    vm.date=formattedDate;
                }
            }
        },
        putCookie: function putSearchParamsToCookie() {
            var date = new Date();
            date.setTime(date.getTime() + (24 * 60 * 60 * 1000)); //24 hour

            var search = {
                departure: this.departure,
                destination: this.destination,
                passengerCount: this.passengerCount,
                departureDate: this.date
            };
            $.cookie('busSearchParams',  JSON.stringify(search), { expires : date,  path : '/' });

        },
        
        pageReloaded: function () {
            if (window.performance &&( performance.navigation.type == 1||performance.navigation.type==2)) {
                var url = window.location.href;
                if (url.includes("#")){
                    this.mainPage = false;
                    this.search();
                }
            }
        },
        
        listenPageChange: function(){
            var vm = this;
            window.onhashchange = function() {
                var url = window.location.href;
                if (!url.includes("#")){
                    vm.mainPage = true;
                    vm.$parent.setPassengerCount(vm.passengerCount);
                    vm.$parent.setBuses([]);
                    vm.$parent.setGUID(null);      
                }
            }
        }
    },
    
    watch: {
        date: function (nval, oval) {

            var selectedDate = $.datepicker.parseDate(datePickerDateFormat, nval);
            var returnDate = new Date(selectedDate);
            returnDate.setFullYear(selectedDate.getFullYear() + 1);
            this.returnDate = $.datepicker.formatDate(datePickerDateFormat, returnDate);
            return nval;
        },
    }
});
